import { useState } from "react";

import { useDispatch} from "react-redux";

import {
    Button,
    Form
} from "react-bootstrap";

import 'bootstrap/dist/css/bootstrap.min.css';

import { setAuthorized } from "./store/authSlice";
import {
    showLoading,
    hideLoading,
    showMsg
} from "./store/pageSlice";

import { Login } from "./api/auth";

import "./App.css";

export default function LoginPage() {
    const dispatch = useDispatch();

    const [sUserID, setsUserID] = useState("");
    const [sPwd, setsPwd] = useState("");

    const submitLogin = async (e) => {
        e.preventDefault();

        dispatch(showLoading());

        try {
            await Login(sUserID, sPwd);

            dispatch(setAuthorized(true));
        } catch (ex) {
            dispatch(showMsg({
                title: "Error Login",
                message: `Unable to login. ${ex.message}`
            }));
        }

        dispatch(hideLoading());
    };

    return (
        <div className="page page-flex-row page-centered page-centered-align">
            <h3 style={{ marginRight: "5%" }}>iFlexi License administrator console</h3>
            <div className="form-panel">
                <div className="form-panel-title">
                    <strong>Login</strong>
                </div>
                <div className="form-panel-body">
                    <Form onSubmit={submitLogin}>
                        <Form.Group className="mb-3">
                            <Form.Label>User ID</Form.Label>
                            <Form.Control onChange={(e) => { setsUserID(e.target.value) }} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" onChange={(e) => { setsPwd(e.target.value) }} />
                        </Form.Group>
                        <Button variant="primary" type="submit">Login</Button>
                    </Form>
                </div>
            </div>
        </div>
    );
}